import React, { useEffect, useState } from 'react';

import styles from './UIAProgressBar.style';

export type UIAProgressBarProps = {
  isLoading: boolean;
  isFinished: boolean;
};

enum ForegroundStylesEnum {
  INITIAL,
  LOADING,
  FINISHED,
}

const foregroundStyles = {
  [ForegroundStylesEnum.INITIAL]: styles.foreground,
  [ForegroundStylesEnum.LOADING]: { ...styles.foreground, ...styles.isLoading },
  [ForegroundStylesEnum.FINISHED]: { ...styles.foreground, ...styles.isFinished },
};

/**
 * UIAProgressBar - Props
 * isLoading - while the generation is ongoing
 * isFinished - when the generation process is done
 */
export const UIAProgressBar = ({ isLoading, isFinished }: UIAProgressBarProps) => {
  const [foregroundStyle, setForegroundStyle] = useState<ForegroundStylesEnum>(ForegroundStylesEnum.INITIAL);

  useEffect(() => {
    if (!isFinished && isLoading) {
      return setForegroundStyle(ForegroundStylesEnum.LOADING);
    }
    if (isFinished) {
      return setForegroundStyle(ForegroundStylesEnum.FINISHED);
    }
    return setForegroundStyle(ForegroundStylesEnum.INITIAL);
  }, [isLoading, isFinished]);

  return (
    <div id="ai-progress-wrapper" style={styles.wrapper}>
      <div id="ia-progress-foreground" style={foregroundStyles[foregroundStyle]}></div>
    </div>
  );
};

export default UIAProgressBar;
